import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { i18n } from '@zet/localization'

import { verifyCustomerDetails } from '../functions/verifyCustomerDetails'

export default function useVerifyCustomerDetails() {
  const toast = useToast()
  const navigation = useNavigation()

  return useMutation(verifyCustomerDetails, {
    onSuccess(response) {
      const { error, data } = response
      if (error) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: error?.message,
          hideAfter: 3000,
        })
      } else {
        const { customerId, nameAsPan, panNo } = data
        navigation.navigate('EmploymentDetails', {
          customerId,
          nameAsPan,
          panNo,
        })
      }
    },
    onError(error: string) {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    },
  })
}
